var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05876 6.07337L12.7613 0.3708C13.0008 0.131308 13.3893 0.131308 13.6288 0.3708C13.8687 0.610642 13.8687 0.998809 13.6288 1.23865L7.05876 7.80873L0.488686 1.23865C0.368764 1.11873 0.308804 0.96164 0.308804 0.804901C0.308804 0.647811 0.368764 0.490721 0.488686 0.3708C0.728178 0.131308 1.11669 0.131308 1.35619 0.3708L7.05876 6.07337Z",
    fill: "#C6C6C6"
  })));
};
export default SvgChevronDown;